export class FilterChange {
  static readonly type = '[TrendAnalysis] FilterChange';
  constructor(public filters: any) {}
}

export class ViewModeChange {
  static readonly type = '[TrendAnalysis] ViewModeChange';
  constructor(public numberMode: boolean = true) {}
}
